import Alpine from 'alpinejs'

Alpine.store('LeaseStickybar', {
  atHeader: false,
  atBooking: false,
  atFooter: false,

  showAtHeader() {
    this.atHeader = true
  },

  hideAtHeader() {
    this.atHeader = false
  },

  showAtBooking() {
    this.atBooking = true
  },

  hideAtBooking() {
    this.atBooking = false
  },

  showAtFooter() {
    this.atFooter = true
  },

  hideAtFooter() {
    this.atFooter = false
  },
})
